import { inRn } from 'lib/helpers/utility';

import PayWithCardModal from 'components/Payments/NewPayment/PaymentContent/components/PaymentMethods/Payroc/PayWithCardModal';
import { usePaymentContext } from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import LightboxWrapper from 'components/Payments/lightbox/LightboxWrapper';
import Modal from 'components/shared/Modal/Modal';

import PayFromKioskModal from './PayFromKioskModal/PayFromKioskModal';

const ProcessPayment = ({
  isOpen,
  handleClose,
  invoice,
  patientId,
  onSuccess,
  onFail,
  practice,
  SuccessScreen,
  token
}) => {
  const { processor, values, terminal, isKiosk, terminalData } = usePaymentContext();

  const isPayroc = processor === 'payroc';

  if (isKiosk && terminalData?.cardPresentTerminal) {
    return (
      <PayFromKioskModal
        isOpen={isOpen}
        handleClose={handleClose}
        patientId={patientId}
        invoice={invoice}
        onSuccess={onSuccess}
        token={token}
      />
    );
  }

  if (isPayroc && terminal?.online) {
    return (
      <PayWithCardModal
        isOpen={isOpen}
        handleClose={handleClose}
        patientId={patientId}
        onSuccess={onSuccess}
      />
    );
  }

  if (isOpen && terminal?.online)
    return (
      <Modal isOpen={isOpen} handleClose={handleClose} width="full">
        <LightboxWrapper
          f_name={invoice?.patient?.first_name}
          l_name={invoice?.patient?.last_name}
          billingAddress={invoice?.patient?.userAddress}
          amount={inRn(values.amount)}
          patientId={patientId}
          practiceId={practice?.id}
          invoiceId={invoice?.id}
          invoiceToken={values.invoiceToken}
          tokenOnly={values.tokenOnly}
          saveCard={values.saveCard}
          surcharge={inRn(values.surchargeAmount)}
          SuccessScreen={SuccessScreen}
          onCancel={handleClose}
          onFail={onFail}
          onApproval={onSuccess}
        />
      </Modal>
    );
};

export default ProcessPayment;
